// ---------------------------------------------------------------------------
// AgentForm.types — local form-state shapes for the agent create/edit form.
// The form edits a single LLM agent (AgentLlmSpec); variables and metadata are
// edited as ordered row lists (each carries a stable client-side `id`) and
// converted to/from the API maps in AgentForm.utils.
// ---------------------------------------------------------------------------

import type { VariableType } from '../../../types/agent.js';

export type AgentFormMode = 'create' | 'view' | 'edit';

// Variable keys follow UPPER_SNAKE_CASE (e.g. MODEL_NAME), per the server.
export const VARIABLE_NAME_PATTERN = /^[A-Z][A-Z0-9_]*$/;

export const VARIABLE_TYPE_OPTIONS: { value: VariableType; label: string }[] = [
  { value: 'String', label: 'String' },
  { value: 'Number', label: 'Number' },
  { value: 'Integer', label: 'Integer' },
  { value: 'Boolean', label: 'Boolean' },
];

export interface VariableRow {
  id: string;
  name: string;
  type: VariableType;
  defaultValue: string;
  description: string;
}

export interface AgentFormState {
  name: string;
  displayName: string;
  description: string;
  // LLM init
  modelName: string;
  systemPrompt: string;
  temperature: string;
  topP: string;
  maxTokens: string;
  contextWindow: string;
  includeConversationHistory: string;
  // LLM invoke
  userMessage: string;
  // Collections
  variables: VariableRow[];
}
